import { QueryClient } from '@tanstack/react-query';
import api from '@api/apiServices';

const setMutationDefaults = (queryClient: QueryClient) => {
    queryClient.setMutationDefaults(['updateSettings'], {
        mutationFn: data => api.settings.patch(undefined, data),
    });

    queryClient.setMutationDefaults(['deleteContact'], {
        mutationFn: id => api.contacts.delete(id),
    });

    queryClient.setMutationDefaults(['updateContact'], {
        mutationFn: data => api.contacts.patchForm(...data),
    });

    queryClient.setMutationDefaults(['createContact'], {
        mutationFn: data => api.contacts.postForm(data),
    });

    queryClient.setMutationDefaults(['duplicateEmailTemplate'], {
        mutationFn: id => api.emails.templates.duplicate(id),
    });

    queryClient.setMutationDefaults(['duplicateEmailTemplateVariant'], {
        mutationFn: id => api.emails.templates.variants.duplicate(id),
    });

    queryClient.setMutationDefaults(['deleteEmailTemplate'], {
        mutationFn: id => api.emails.templates.delete(id),
    });

    queryClient.setMutationDefaults(['deleteEmailTemplateVariant'], {
        mutationFn: id => api.emails.templates.variants.delete(id),
    });

    queryClient.setMutationDefaults(['updateEmailTemplate'], {
        mutationFn: data => api.emails.templates.patchForm(...data),
    });

    queryClient.setMutationDefaults(['updateEmailDesign'], {
        mutationFn: data => api.emails.designs.patchForm(...data),
    });

    queryClient.setMutationDefaults(['duplicateEmailDesign'], {
        mutationFn: id => api.emails.designs.duplicate(id),
    });

    queryClient.setMutationDefaults(['deleteEmailDesign'], {
        mutationFn: id => api.emails.designs.delete(id),
    });

    queryClient.setMutationDefaults(['duplicateEmailDraft'], {
        mutationFn: id => api.emails.drafts.duplicate(id),
    });

    queryClient.setMutationDefaults(['duplicateScheduledEmail'], {
        mutationFn: id => api.emails.scheduled.duplicate(id),
    });

    queryClient.setMutationDefaults(['deleteEmailDraft'], {
        mutationFn: id => api.emails.drafts.delete(id),
    });

    queryClient.setMutationDefaults(['createEmailDraft'], {
        mutationFn: data => api.emails.drafts.post(data),
    });

    queryClient.setMutationDefaults(['newEmailDraft'], {
        mutationFn: data => api.emails.drafts.postForm(data),
    });

    queryClient.setMutationDefaults(['updateEmailDraft'], {
        mutationFn: data => api.emails.drafts.patch(...data),
    });

    queryClient.setMutationDefaults(['updateEmailDraftForm'], {
        mutationFn: data => api.emails.drafts.patchForm(...data),
    });

    queryClient.setMutationDefaults(['scheduleEmailDraft'], {
        mutationFn: data => api.emails.drafts.schedule(...data),
    });

    queryClient.setMutationDefaults(['sendEmailDraft'], {
        mutationFn: id => api.emails.drafts.send(id),
    });

    queryClient.setMutationDefaults(['deleteSentEmail'], {
        mutationFn: id => api.emails.sent.delete(id),
    });

    queryClient.setMutationDefaults(['duplicateSentEmail'], {
        mutationFn: id => api.emails.sent.duplicate(id),
    });

    queryClient.setMutationDefaults(['unscheduleEmail'], {
        mutationFn: id => api.emails.scheduled.unschedule(id),
    });

    queryClient.setMutationDefaults(['deleteScheduledEmail'], {
        mutationFn: id => api.emails.scheduled.delete(id),
    });

    queryClient.setMutationDefaults(['create', 'contactFilter'], {
        mutationFn: data => api.contacts.filters.post(data),
    });

    queryClient.setMutationDefaults(['delete', 'contactFilter'], {
        mutationFn: id => api.contacts.filters.delete(id),
    });

    queryClient.setMutationDefaults(['batchUpdateGroupContactsItems'], {
        mutationFn: ({ groupId, ...data }) =>
            api.contacts.groups[groupId].contacts.batchPatch(data),
    });

    queryClient.setMutationDefaults(['batchRemoveGroupContactsItems'], {
        mutationFn: ({ groupId, data }) =>
            api.contacts.groups[groupId].contacts.batchDelete(data),
    });

    queryClient.setMutationDefaults(['deleteContactsGroup'], {
        mutationFn: id => api.contacts.groups.delete(id),
    });

    queryClient.setMutationDefaults(['updateContactsGroup'], {
        mutationFn: data => api.contacts.groups.patch(...data),
    });

    queryClient.setMutationDefaults(['addContactsToGroup'], {
        mutationFn: ({ groupId, contactIds }) =>
            api.contacts.groups[groupId].contacts.add.post(contactIds),
    });

    queryClient.setMutationDefaults(['addDomainEmail'], {
        mutationFn: data => api.settings.emails.domains.emails.post(data),
    });

    queryClient.setMutationDefaults(['deleteDomainEmail'], {
        mutationFn: id => api.settings.emails.domains.emails.delete(id),
    });

    queryClient.setMutationDefaults(['updateDomainEmail'], {
        mutationFn: data => api.settings.emails.domains.emails.patch(...data),
    });

    queryClient.setMutationDefaults(['addSingleEmail'], {
        mutationFn: data => api.settings.emails['single-emails'].post(data),
    });

    queryClient.setMutationDefaults(['deleteSingleEmail'], {
        mutationFn: id => api.settings.emails['single-emails'].delete(id),
    });

    queryClient.setMutationDefaults(['updateSingleEmail'], {
        mutationFn: data => api.settings.emails['single-emails'].patch(...data),
    });

    queryClient.setMutationDefaults(['testEmail'], {
        mutationFn: ({ emailId, ...data }) =>
            api.emails.drafts[emailId]['send-test'].post(data),
    });

    queryClient.setMutationDefaults(['uploadContacts'], {
        mutationFn: data => api.contacts.upload.postForm(data),
    });
};

export default setMutationDefaults;
